import { Loader } from "rsuite";
import useAuth from "../hooks/useAuth";

const FallBackLoader = ({ title }) => {
  const { currentUser } = useAuth();
  return (
    <Loader
      size="lg"
      backdrop
      content={
        currentUser
          ? currentUser?.organization?.first_name !== undefined &&
            currentUser?.organization?.first_name !== "undefined" &&
            currentUser?.organization?.last_name !== undefined &&
            currentUser?.organization?.last_name !== "undefined"
            ? `${currentUser?.organization?.first_name} ${currentUser?.organization?.last_name} ...`
            : `${title !== undefined ? title : "Trip Merchant"} ...`
          : `${title !== undefined ? title : "Trip Merchant"} ...`
      }
      vertical
      center
      classPrefix="loader"
    />
  );
};

export default FallBackLoader;
